var _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThunder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 128,
    viewBox: "0 0 129 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64.666,
    cy: 64,
    r: 63.5,
    stroke: "url(#paint0_linear_2577_2856)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.3873 54.8052C90.2413 54.5475 90.0295 54.3332 89.7736 54.184C89.5177 54.0349 89.2269 53.9563 88.9307 53.9563H66.9968L70.6741 25.8597C70.7136 25.4837 70.6253 25.1053 70.4236 24.7855C70.2219 24.4657 69.9184 24.2231 69.5621 24.0968C69.2057 23.9705 68.8172 23.9677 68.4591 24.089C68.101 24.2103 67.7941 24.4486 67.5879 24.7655L40.914 71.4971C40.7581 71.7508 40.6726 72.0415 40.6664 72.3393C40.6602 72.637 40.7335 72.931 40.8788 73.191C41.0242 73.4509 41.2362 73.6674 41.493 73.8182C41.7499 73.9689 42.0423 74.0483 42.3401 74.0484H63.9462L61.032 102.187C61.0034 102.562 61.1009 102.936 61.309 103.248C61.5172 103.561 61.824 103.796 62.1807 103.914C62.5373 104.033 62.9234 104.028 63.2774 103.902C63.6314 103.776 63.9329 103.535 64.1342 103.217L90.3672 56.4909C90.5194 56.2368 90.6014 55.9469 90.6049 55.6508C90.6084 55.3546 90.5334 55.0629 90.3873 54.8052Z",
    fill: "url(#paint1_linear_2577_2856)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2577_2856",
    x1: 7.55245,
    y1: 18.7399,
    x2: 120.519,
    y2: 75.2731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E73964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6A632"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2577_2856",
    x1: 43.3527,
    y1: 35.7124,
    x2: 93.5642,
    y2: 51.3982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E73964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6A632"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunder);
export default __webpack_public_path__ + "static/media/thunder.d4716aa203fa2a9a24d260a6ae3b5e43.svg";
export { ForwardRef as ReactComponent };